import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { setDataAttr, lazyLoadImgs } from '../../../../utils/helper';
import HomeEyeCheckUp from '../HomeEyeCheckUp/HomeEyeCheckUp';
import ContactLens from '../Menu/ContactLens';
import GridMenu from '../Menu/GridMenu';
import Menu from '../Menu/Menu';
import './MainMenu.scss';

const redirection = (key, data, props) => {
  const { updateNavValueDtm } = props;
  const dataAttr =
    data.gaObj && Object.keys(data.gaObj).length > 0 ? setDataAttr(data.gaObj) : null;
  return data.url && data.url.indexOf('lenskart.com') === -1 ? (
    <Link
      className="getGaData"
      {...dataAttr}
      to={{ pathname: data.url, state: { categoryId: data.categoryId, section: 'cat' } }}
      onClick={e => updateNavValueDtm(key, '', '', '', e, key)}
    >
      {key}
    </Link>
  ) : (
    <a
      className="getGaData"
      {...dataAttr}
      href={data.url}
      onClick={e => updateNavValueDtm(key, '', '', '', e, key)}
    >
      {key}
    </a>
  );
};
const MainMenu = props => {
  const {
    updateNavDtm,
    navData,
    updateNavValueDtm,
    location,
    dataLocale,
    triggerDataLayerOnCtaClick,
    localeInfo,
  } = props;
  const [isMounted, setIsMounted] = useState(false);
  useEffect(() => {
    setIsMounted(true);
  }, []);
  if (isMounted) lazyLoadImgs();
  return (
    <div className="main-menu fs13 margin-l0" id="cssmenu">
      {' '}
      {navData.menu
        ? navData.menu.map(data => {
            let itemlists = '';
            return Object.keys(data).map((key, index) => {
              if (data[key].type === 'two-col-layout') {
                itemlists = (
                  <div
                    key={index}
                    className={
                      data[key].url === location.pathname
                        ? 'nav-level-1 try-at-home active-nav'
                        : 'nav-level-1 try-at-home'
                    }
                  >
                    <a>
                      <span>{key.toUpperCase()}</span>
                    </a>
                    <HomeEyeCheckUp
                      cta={data[key].cta}
                      dataLocale={dataLocale}
                      menuData={data[key]}
                      parentMenu={data}
                      section={key}
                      updateNavDtm={updateNavDtm}
                    />
                  </div>
                );
              } else if (data[key].type === 'grid') {
                itemlists = (
                  <div key={index} className="nav-level-1 grid">
                    <a>
                      <span>{key.toUpperCase()}</span>
                    </a>
                    <GridMenu
                      dataLocale={dataLocale}
                      menuData={data[key]}
                      parentMenu={data[key]}
                      section={key}
                      updateNavValueDtm={updateNavValueDtm}
                    />
                  </div>
                );
              } else if (data[key].type === 'list-grid') {
                itemlists = (
                  <div
                    key={index}
                    className={
                      data[key].url === location.pathname ? 'nav-level-1 active-nav' : 'nav-level-1'
                    }
                  >
                    {redirection(key.toUpperCase(), data[key], props)}
                    <ContactLens
                      dataLocale={dataLocale}
                      menuData={data[key]}
                      parentMenu={data}
                      section={key}
                      triggerDataLayerOnCtaClick={triggerDataLayerOnCtaClick}
                      updateNavValueDtm={updateNavValueDtm}
                    />
                  </div>
                );
              } else if (data[key].type === 'three-col-layout') {
                itemlists = (
                  <div
                    key={index}
                    className={
                      data[key].url === location.pathname
                        ? 'nav-level-1 active-nav three-col-layout'
                        : 'nav-level-1 three-col-layout'
                    }
                  >
                    {redirection(key.toUpperCase(), data[key], props)}
                    <Menu
                      dataLocale={dataLocale}
                      menuData={data[key]}
                      parentMenu={data}
                      section={key}
                      updateNavValueDtm={updateNavValueDtm}
                    />
                  </div>
                );
              } else {
                itemlists = (
                  <div
                    key={index}
                    className={
                      data[key].url === location.pathname ? 'nav-level-1 active-nav' : 'nav-level-1'
                    }
                  >
                    {redirection(key.toUpperCase(), data[key], props)}
                  </div>
                );
              }
              return itemlists;
            });
          })
        : ''}{' '}
    </div>
  );
};

MainMenu.defaultProps = {
  navData: {},
};

export default MainMenu;
